import { render } from "./MarketplaceForm.vue?vue&type=template&id=f9dadc7a"
import script from "./MarketplaceForm.vue?vue&type=script&lang=js"
export * from "./MarketplaceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__